import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_BUMMER_ACTIVATION, SET_BUMMER_COMPLETION } = LOCAL;

export default {
	namespaced: true,
	state: {
		id: null,
		title: "",
		active: false,
		complete: false,
		model: "",
	},
	actions: {
		activate({ dispatch, commit, state }) {
			commit(SET_BUMMER_ACTIVATION, { active: true });
			dispatch("global/modal/activate", { component: "SpinResultModal", data: state }, ROOT_FLAG);
		},
		deactivate({ dispatch, commit }) {
			commit(SET_BUMMER_ACTIVATION, { active: false });
			dispatch("global/modal/deactivate", {}, ROOT_FLAG);
			dispatch("game/bummers/deactivate", {}, ROOT_FLAG);
		},
		complete({ dispatch, commit, state }, data) {
			dispatch(`${state.model}/complete`, data);
			commit(SET_BUMMER_COMPLETION, { complete: true });
			dispatch("deactivate", state);
			dispatch("game/hints/randomize", {}, ROOT_FLAG);
		},
	},
	mutations: {
		[SET_BUMMER_ACTIVATION](state, activation) {
			state.active = activation.active;
		},
		[SET_BUMMER_COMPLETION](state, { complete }) {
			state.complete = complete;
		},
	},
};
